'use client';
import styled from 'styled-components';
import { generateContentIconStyle } from '@ui/icons';
import { ResponsiveImage } from '@web/molecules/ResponsiveImage';

export const StyledRadioInput = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing(4)};
  width: 100%;
  align-items: center;
  @media ${props => props.theme.laptop} {
    flex-direction: ${props => props.direction};
  }
`;

export const Label = styled.label`
  align-items: center;
  background-color: ${props =>
    props.checked
      ? props.theme.colors.secondary.egg
      : 'rgba(232, 228, 215, 0.35)'};
  border: 2px solid
    ${props =>
      props.error
        ? props.theme.colors.status.errorPrimary
        : props.checked
        ? props.theme.colors.secondary.egg
        : props.disabled
        ? 'transparent'
        : 'rgba(166, 153, 145, 0.35)'};
  border-radius: 500px;
  color: ${props => props.theme.colors.text.primary};
  cursor: pointer;
  display: grid;
  grid-template-columns: 30px 1fr;
  flex: 1;
  padding: ${props => props.theme.spacing(4)};
  text-align: center;

  ${({ theme }) => theme.typography.body}

  &:hover,
  &:focus-within {
    cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
    border: ${props => (props.disabled ? '1px' : '2px')} solid
      ${props =>
        props.error
          ? props.theme.colors.status.errorPrimary
          : props.disabled
          ? 'transparent'
          : props.theme.colors.hero.spinach};
  }

  &::before {
    ${props =>
      props.checked
        ? generateContentIconStyle('radiobox-marked')
        : generateContentIconStyle('radiobox-blank')};
    width: ${props => props.theme.spacing(6)};
    height: ${props => props.theme.spacing(6)};
    background-color: ${props => props.theme.colors.border.dark};
  }
  text-wrap: nowrap;
  opacity: ${props => (props.disabled ? 0.5 : 1)};
  width: 100%;
  max-height: 60px;
`;

export const StyledFieldset = styled.fieldset`
  border-width: 0px;
  width: 100%;
  padding-top: 0px;
  padding-bottom: 0px;
`;

export const StyledLegend = styled.legend`
  position: absolute;
  height: 1px;
  width: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;

export const StyledCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.theme.colors.background.lightest};
  border-radius: ${props => props.theme.spacing(8)};
  padding: 21px 24px 26px 24px;
  box-shadow: ${props =>
    props.checked ? '0 2px 4px rgba(0, 0, 0, 0.2)' : 'none'};
  border: ${props =>
    props.checked ? `2px solid ${props.theme.colors.secondary.egg}` : `none`};
  cursor: pointer;
  transition: all 0.2s ease;
  width: 343px;
  height: 323px;

  &:hover {
    border-color: ${props => props.theme.colors.border.hover};
  }

  .radio-description {
    color: ${props => props.theme.colors.text.secondary};
    font-size: ${props => props.theme.spacing(3)};
  }
  @media ${props => props.theme.laptop} {
    margin: ${props => props.theme.spacing(2)};
  }
`;

export const StyledHeading = styled.h4`
  ${props => props.theme.typography.heading4}
  font-weight: bold;
  margin-bottom: ${props => props.theme.spacing(2)};
`;

export const StyledSubheading = styled.h4`
  ${props => props.theme.typography.body}
  text-align: center;
  margin-bottom: ${props => props.theme.spacing(1)};
  min-height: 40px;
`;

export const StyledImage = styled(ResponsiveImage)`
  margin-bottom: 17px;
  align-self: center;
  border-radius: 50%;
`;
